import { localHostText } from "./constants"

export const getWindowHref = () => {
    return window.location.href
}
export const isLocalHost = () => {
    return getWindowHref().indexOf(localHostText) > -1
}